import React from "react";
import {Button, Image} from "antd";
import {DownloadOutlined} from "@ant-design/icons";

const FilePreview = ({fileUrl}) => {

    if (!fileUrl) {
        return null;
    }

    const getFileExtension = (url) => {
        return url.split(".").pop().toLowerCase().split("?")[0].split("#")[0];
    };

    const renderPreview = () => {
        const ext = getFileExtension(fileUrl);

        const imageExts = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];
        const videoExts = ["mp4", "webm", "ogg"];
        const audioExts = ["mp3", "wav", "ogg"];

        if (imageExts.includes(ext)) {
            return <Image src={fileUrl} className={'rounded-lg'} alt="Image preview"
                          style={{maxWidth: "100%", maxHeight: 200}}/>;
        } else if (videoExts.includes(ext)) {
            return (
                <video controls style={{maxWidth: "100%", maxHeight: 200}}>
                    <source src={fileUrl} type={`video/${ext}`}/>
                    مرورگر شما از پخش ویدیو پشتیبانی نمی‌کند.
                </video>
            );
        } else if (audioExts.includes(ext)) {
            return (
                <audio controls style={{width: "100%"}}>
                    <source src={fileUrl} type={`audio/${ext}`}/>
                    مرورگر شما از پخش صوت پشتیبانی نمی‌کند.
                </audio>
            );
        } else {
            return (
                <Button type="primary" icon={<DownloadOutlined/>} href={fileUrl} target="_blank">
                    دانلود فایل
                </Button>
            );
        }
    };

    return <div>{renderPreview()}</div>;
};

export default FilePreview;
